import { Alert, Card, Empty, Typography } from "antd";
import ListTable from "common/ListTable";
import { postData } from "apiServices/common";
import { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import "./style.css";
export default function RecommendationAgainstDefects({
  line_id,
  date,
  currentSlide,
  slideId,
}) {
  const [searchParams] = useSearchParams();
  const effectiveDate = date || searchParams?.get("date");
  const [dataSource, setDataSource] = useState();
  const [loading, setLoading] = useState(false);
  const initialGetData = useCallback(async () => {
    setLoading(true);
    const payload = {
      line_id: line_id,
      ...(effectiveDate ? { date: effectiveDate } : {}),
    };
    const response = await postData(
      "/api/digitalization/bigscreen-dashboard/recommendation-defects",
      payload,
    );
    setLoading(false);
    if (response && response?.code === 200) {
      const data = response?.data;
      setDataSource(data);
    }
  }, [line_id, effectiveDate]);
  useEffect(() => {
    if (line_id && currentSlide === slideId) {
      initialGetData();
    }
  }, [line_id, currentSlide, slideId, initialGetData]);

  const columns = [
    {
      title: "Recommendation",
      dataIndex: "name",
      key: "name",
      className: "name",
    },
    {
      title: "No of Case",
      dataIndex: "value",
      key: "value",
      className: "value",
    },
  ];
  return (
    <Card
      style={{
        width: "100%",
        height: "100%",
      }}
    >
      {loading ? (
        <ListTable
          loading
          className="recommendation-against-defects"
          columns={columns}
          dataSource={[]}
          pagination={false}
          bordered
          emptyText="No records to show yet."
        />
      ) : Array.isArray(dataSource?.chart_data) &&
        dataSource?.chart_data?.length > 0 ? (
        <div>
          <Typography.Title level={4}>
            Recommendation Against Defects
          </Typography.Title>
          <ListTable
            className="recommendation-against-defects"
            columns={columns}
            dataSource={dataSource?.chart_data}
            pagination={false}
            bordered
            emptyText="No records to show yet."
          />
        </div>
      ) : (
        <Empty
          style={{
            width: "33%",
            margin: "auto",
            marginTop: "10%",
            marginBottom: "10%",
            height: "100%",
          }}
          description={
            <Alert
              message="No Data Found with selected line-id in Recommendation Against Defects"
              type="warning"
            />
          }
        />
      )}
    </Card>
  );
}
